import { BaseComponentProps } from '@/components/BaseComponentProps';
import { cn } from '@agnes/ui';

export interface BadgeRubricaNaturezaProps extends BaseComponentProps {
  codigo: string | number;
}

export function BadgeRubricaNatureza({
  codigo,
  className,
  dataQa,
  ...props
}: BadgeRubricaNaturezaProps) {
  return (
    <span
      data-qa={dataQa ? `${dataQa}-badge-incidencia` : undefined}
      className={cn(className, 'rounded bg-agnes-bg-muted px-2 py-0.5 text-xs text-agnes-text')}
      {...props}
    >
      {codigo}
    </span>
  );
}
